// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_header_summary-module__description--2nLZm{margin:0px;font-family:inherit;white-space:pre-wrap;margin-bottom:10px}@media screen and (max-width: 62.5625em){.lawyer_header_summary-module__description--2nLZm{padding:0px 16px}}.lawyer_header_summary-module__subtitle--2w1h0{margin-top:5px;padding-top:16px;border-top:1px solid #dce0e0}@media screen and (max-width: 62.5625em){.lawyer_header_summary-module__subtitle--2w1h0{margin-top:16px;margin-bottom:0px;font-size:inherit;line-height:inherit}}\n", ""]);
// Exports
exports.locals = {
	"description": "lawyer_header_summary-module__description--2nLZm",
	"subtitle": "lawyer_header_summary-module__subtitle--2w1h0"
};
module.exports = exports;
